import { IconConfig } from "../types";

export const bell: IconConfig = {
  type: 'fill' as const,
  viewBox: "1 5 19 17",
  paths: [
    "M19.688 17.634c-.679-.73-1.949-1.827-1.949-5.422a5.55 5.55 0 0 0-4.492-5.452v-.732a1.124 1.124 0 1 0-2.248 0v.732a5.55 5.55 0 0 0-4.5 5.452c0 3.591-1.271 4.691-1.952 5.422a1.1 1.1 0 0 0-.3.763 1.126 1.126 0 0 0 1.128 1.125h13.487a1.125 1.125 0 0 0 1.128-1.125 1.1 1.1 0 0 0-.3-.763ZM13.102 22.895a2.25 2.25 0 0 1-2.252-2.249h4.5a2.25 2.25 0 0 1-2.248 2.249Z"
  ] as const
}
